import {
    GET_CURRENT_GROUP
} from './constants';

const initialState = {
    currentGroup: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENT_GROUP: {
            return {
                ...state,
                currentGroup: action.payload,
            };
        }
        default:
            return state;
    }
};

